var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinesAndDotsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "dotsLinesPattern",
    width: 400,
    height: 200,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#78E01D",
    strokeOpacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 1.5,
    fill: "#78E01D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 80,
    r: 1.5,
    fill: "#78E01D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 100,
    r: 1.5,
    fill: "#78E01D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 200,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 80,
    x2: 350,
    y2: 100
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#dotsLinesPattern)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesAndDotsBg);
export default __webpack_public_path__ + "static/media/lines-and-dots-bg.de991e1f653669ae103c72acd8849c19.svg";
export { ForwardRef as ReactComponent };